import { gql } from 'apollo-angular'

export default gql`
  query reportsDetails($id: Int!) {
    report_by_pk(id: $id) {
      stored_file {
        key
      }
      id
      reportTypeId
      survey_test {
        scanner {
          id
          name
          facility {
            id
            name
          }
          facility_room {
            id
            name
          }
        }
        survey_test_routine {
          name
        }
      }
      scanner {
        id
        name
        facility {
          id
          name
        }
        facility_room {
          id
          name
        }
      }
      dateCreated
      month
      year
    }
  }
`
